import React, { useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";
import ReactWOW from "react-wow";
import { Link } from "react-scroll";
import "./../css/home.scss";
import { Container, Tab, Row, Col, Nav, CardDeck, Card } from "react-bootstrap";

import "react-multi-carousel/lib/styles.css";

import FormFormik from "./../component/FormikLead";
import Techstacks from "./../component/techstacks";

/* start new images */
import wehelp1x from "./../images/home/we-help-1x.png";
import wehelp2x from "./../images/home/we-help-2x.png";
import weoffer11x from "./../images/home/we-offer-1-1x.png";
import weoffer12x from "./../images/home/we-offer-1-2x.png";
import weoffer21x from "./../images/home/we-offer-2-1x.png";
import weoffer22x from "./../images/home/we-offer-2-2x.png";
import weoffer31x from "./../images/home/we-offer-3-1x.png";
import weoffer32x from "./../images/home/we-offer-3-2x.png";
import productsSlide11x from "./../images/home/productsSlide1-1x.png";
import productsSlide12x from "./../images/home/productsSlide1-2x.png";
import productsSlide21x from "./../images/home/productsSlide2-1x.png";
import productsSlide22x from "./../images/home/productsSlide2-2x.png";
import casestudies11x from "./../images/home/case-studies-1-1x.png";
import casestudies12x from "./../images/home/case-studies-1-2x.png";
import casestudies21x from "./../images/home/case-studies-2-1x.png";
import casestudies22x from "./../images/home/case-studies-2-2x.png";
import casestudies31x from "./../images/home/case-studies-3-1x.png";
import casestudies32x from "./../images/home/case-studies-3-2x.png";
import casestudies41x from "./../images/home/case-studies-4-1x.png";
import casestudies42x from "./../images/home/case-studies-4-2x.png";
import ourteam11x from "./../images/home/our-team-1-1x.png";
import ourteam12x from "./../images/home/our-team-1-2x.png";
import ourteam21x from "./../images/home/our-team-2-1x.png";
import ourteam22x from "./../images/home/our-team-2-2x.png";
import ourteam31x from "./../images/home/our-team-3-1x.png";
import ourteam32x from "./../images/home/our-team-3-2x.png";
import ourteam41x from "./../images/home/our-team-4-1x.png";
import ourteam42x from "./../images/home/our-team-4-2x.png";
import ourteam51x from "./../images/home/our-team-5-1x.png";
import ourteam52x from "./../images/home/our-team-5-2x.png";
import ourteam61x from "./../images/home/our-team-6-1x.png";
import ourteam62x from "./../images/home/our-team-6-2x.png";
import ourteam71x from "./../images/home/our-team-7-1x.png";
import ourteam72x from "./../images/home/our-team-7-2x.png";
import ourteam81x from "./../images/home/our-team-8-1x.png";
import ourteam82x from "./../images/home/our-team-8-2x.png";
import ourteam91x from "./../images/home/our-team-9-1x.png";
import ourteam92x from "./../images/home/our-team-9-2x.png";
import ourcustomers21x from "./../images/home/our-customers-2.svg";
import ourcustomers22x from "./../images/home/our-customers-2.svg";
import ourcustomers31x from "./../images/home/our-customers-3.png";
import ourcustomers32x from "./../images/home/our-customers-3.png";
/* end new images */

import imgCardOne from "./../img/imgCardOne.svg";
import imgCardTwo from "./../img/imgCardTwo.svg";
import imgCardThree from "./../img/imgCardThree.svg";
import imgCardFour from "./../img/imgCardFour.svg";
import formFigura1 from "./../img/formFigura1.svg";
import formFigura2 from "./../img/formFigura2.svg";
import formFigura3 from "./../img/formFigura3.svg";

function HomePage(props) {
  const [homeImgWD, setHomeImgWD] = useState('');
  const [imgWeOfferSlide1WD, setImgWeOfferSlide1WD] = useState('');
  const [imgWeOfferSlide2WD, setImgWeOfferSlide2WD] = useState('');
  const [imgWeOfferSlide3WD, setImgWeOfferSlide3WD] = useState('');
  const [productsSlide1WD, setProductsSlide1WD] = useState('');
  const [productsSlide2WD, setProductsSlide2WD] = useState('');
  const [casestudies1WD, setCasestudies1WD] = useState('');
  const [casestudies2WD, setCasestudies2WD] = useState('');
  const [casestudies3WD, setCasestudies3WD] = useState('');
  const [casestudies4WD, setCasestudies4WD] = useState('');
  const [ourteam1WD, setOurteam1WD] = useState('');
  const [ourteam2WD, setOurteam2WD] = useState('');
  const [ourteam3WD, setOurteam3WD] = useState('');
  const [ourteam4WD, setOurteam4WD] = useState('');
  const [ourteam5WD, setOurteam5WD] = useState('');
  const [ourteam6WD, setOurteam6WD] = useState('');
  const [ourteam7WD, setOurteam7WD] = useState('');
  const [ourteam8WD, setOurteam8WD] = useState('');
  const [ourteam9WD, setOurteam9WD] = useState('');

  const [ourcustomers2WD, setOurcustomers2WD] = useState('');
  const [ourcustomers3WD, setOurcustomers3WD] = useState('');
  // console.log("props widthDesctop::",props.wd);

  useEffect(() => {
    if( props.wd < 1200 ){
      setHomeImgWD(wehelp1x);
      setImgWeOfferSlide1WD(weoffer11x);
      setImgWeOfferSlide2WD(weoffer21x);
      setImgWeOfferSlide3WD(weoffer31x);
      setProductsSlide1WD(productsSlide11x);
      setProductsSlide2WD(productsSlide21x);
      setCasestudies1WD(casestudies11x);
      setCasestudies2WD(casestudies21x);
      setCasestudies3WD(casestudies31x);
      setCasestudies4WD(casestudies41x);
      setOurteam1WD(ourteam11x);
      setOurteam2WD(ourteam21x);
      setOurteam3WD(ourteam31x);
      setOurteam4WD(ourteam41x);
      setOurteam5WD(ourteam51x);
      setOurteam6WD(ourteam61x);
      setOurteam7WD(ourteam71x);
      setOurteam8WD(ourteam81x);
      setOurteam9WD(ourteam91x);
      setOurcustomers2WD(ourcustomers21x);
      setOurcustomers3WD(ourcustomers31x);
    } else if( props.wd >= 1200 ){
      setHomeImgWD(wehelp2x);
      setImgWeOfferSlide1WD(weoffer12x);
      setImgWeOfferSlide2WD(weoffer22x);
      setImgWeOfferSlide3WD(weoffer32x);
      setProductsSlide1WD(productsSlide12x);
      setProductsSlide2WD(productsSlide22x);
      setCasestudies1WD(casestudies12x);
      setCasestudies2WD(casestudies22x);
      setCasestudies3WD(casestudies32x);
      setCasestudies4WD(casestudies42x);
      setOurteam1WD(ourteam12x);
      setOurteam2WD(ourteam22x);
      setOurteam3WD(ourteam32x);
      setOurteam4WD(ourteam42x);
      setOurteam5WD(ourteam52x);
      setOurteam6WD(ourteam62x);
      setOurteam7WD(ourteam72x);
      setOurteam8WD(ourteam82x);
      setOurteam9WD(ourteam92x);
      setOurcustomers2WD(ourcustomers22x);
      setOurcustomers3WD(ourcustomers32x);
    }
  },[props.wd]);

  return (
      <div>
        <Container className="pl-0 pr-0">
          <div className="wrapBG">
            <Row className="align-items-center firstBlockRow">
              <Col xl="5" lg="5" md="12" sm="12">
                <div className="h1HomeTop bigText animate__animated animate__delay-1s animate__fadeInLeft">
                  <span className="colorAzure">Ваш</span> надійний постачальник ІТ для страхування
                </div>
                <p className="pHomeTop">
                  Ми надаємо широкий перелік преміум ІТ-послуг, продуктів та рішень для задоволення унікальних потреб наших клієнтів у страховій галузі.
                </p>
                <Link
                    to="idWrapForm"
                    smooth={true}
                    className="btn buttonOne animate__animated animate__delay-1s animate__fadeInLeft"
                >
                  Вперед
                </Link>
              </Col>
              <Col xl="7" lg="7" md="12" sm="12" className="firstBlockRowImg">
                <img
                    src={homeImgWD}
                    className="imgBlock1 animate__animated animate__delay-1s animate__fadeInRight"
                    alt=" "
                    title=" "
                />
              </Col>
            </Row>
            <Row className="mt-5 mb-5">
              <Col xl="12" lg="12" md="12" sm="12">
                <ReactWOW delay="1s" animation="slideInUp">
                  <h2 className="titleH2 mt-5 animate__animated animate__delay-1s animate__slideInUp">
                    Ми пропонуємо
                  </h2>
                </ReactWOW>
              </Col>
            </Row>
            <Row className="wrapWeOffer mt-5 mb-5">
              <Tab.Container defaultActiveKey="software">
                <Row className="rowTabContainer">
                  <Col
                      xl="6"
                      lg="6"
                      md="12"
                      sm="12"
                      className="weOfferLeftPanel"
                  >
                    <ReactWOW delay="1s" animation="fadeInUp">
                      <Nav
                          variant="pills"
                          className="flex-column mt-5 animate__animated animate__delay-1s animate__fadeInUp"
                      >
                        <Nav.Item>
                          <Nav.Link className="textTab" eventKey="software">
                            <span>РОЗРОБКА ПРОГРАМНОГО ЗАБЕЗПЕЧЕННЯ</span>
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link className="textTab" eventKey="technology">
                            <span>ТЕХНОЛОГІЧНА КОНСУЛЬТАЦІЯ</span>
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link className="textTab" eventKey="product">
                            <span>РОЗРОБКА ПРОДУКТУ</span>
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </ReactWOW>
                  </Col>
                  <Col xl="6" lg="6" md="12" sm="12">
                    <Tab.Content className="mt-5">
                      <Tab.Pane
                          eventKey="software"
                          className=""
                      >
                        <img
                            src={imgWeOfferSlide1WD}
                            className="imgTab"
                            alt="Software Development"
                        />
                        <div className="wrapWeOfferText">
                          <h2 className="h2Tab">
                            РОЗРОБКА ПРОГРАМНОГО ЗАБЕЗПЕЧЕННЯ
                          </h2>
                          <p className="pTab">
                            Наша команда експертів забезпечить проведення повного життєвого циклу проекту, від початкової концепції до виходу на ринок готового рішення.
                          </p>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane
                          eventKey="technology"
                          className=""
                      >
                        <img
                            src={imgWeOfferSlide2WD}
                            className="imgTab"
                            alt="Mobile Development Services"
                        />
                        <h2 className="h2Tab">
                          ТЕХНОЛОГІЧНА КОНСУЛЬТАЦІЯ
                        </h2>
                        <p className="pTab">
                          Наша команда експертів в галузі страхування разом з кваліфікованими фахівцями з розробки підготують оптимальні рішення.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane
                          eventKey="product"
                          className=""
                      >
                        <img
                            src={imgWeOfferSlide3WD}
                            className="imgTab"
                            alt="UI/UX Design"
                        />
                        <h2 className="h2Tab">
                          РОЗРОБКА ПРОДУКТУ
                        </h2>
                        <p className="pTab">
                          Ми створили набір готових до використання програмних продуктів, які направлені на задоволення унікальних вимог страхової галузі.
                        </p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Row>
            <Row className="wrapHomeProduct1">
              <Col>
                <h2 className="titleH2">
                  Продукти
                </h2>
              </Col>
            </Row>
            <div className="wrapBlockBGLeft">
              <Row className="align-items-center">
                <Container>
                  <Carousel className="wrapCarouselProduct">
                    <Carousel.Item>
                      <div className="wrapCaruselItem">
                        <img
                            className="caruselHomeProductSlide"
                            src={productsSlide1WD}
                            alt="carusel 1"
                        />
                        <Carousel.Caption className="wrapTextBlock">
                          <h3 className="h3Carusel">SAGACITY - API ПЛАТФОРМА ДЛЯ СТРАХУВАННЯ</h3>
                          <p className="pCarusel">
                            Наша API платформа Sagacity надає:
                            <br/>- Швидке налаштування продукту.
                            <br/>- Готові API для оптимізації всього процесу продажу.
                            <br/>- Можливість продавати широкий спектр страхових продуктів онлайн.
                            <br/>- Гнучкість налаштування та кастомізації бізнес-процесів для покращення операцій з продажу.
                          </p>
                          <a href="/ua/product/sagacity-insurance-api" className="btn buttonOne buttonOneCarusel">
                            Дивитись більше
                          </a>
                        </Carousel.Caption>
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="wrapCaruselItem">
                        <img
                            className="caruselHomeProductSlide"
                            src={productsSlide2WD}
                            alt="carusel 2"
                        />
                        <Carousel.Caption className="wrapTextBlock">
                          <h3 className="h3Carusel">SAGACITY ІНТЕРНЕТ-МАГАЗИН СТРАХОВИХ ПОЛІСІВ</h3>
                          <p className="pCarusel">
                            Наш Інтернет-магазин страхових полісів  має:
                            <br/>- Швидкий вихід на ринок, що гарантує оперативний запуск продукту.
                            <br/>- Повний онлайн-процес продажів від початку до кінця.
                            <br/>- Широкий вибір страхових продуктів.
                            <br/>- Управління продуктами з використанням зручного інструменту low-code програмування.
                          </p>
                          <a href="/ua/product/online-insurance-products" className="btn buttonOne buttonOneCarusel">
                            Дивитись більше
                          </a>
                        </Carousel.Caption>
                      </div>
                    </Carousel.Item>
                  </Carousel>
                </Container>
              </Row>
              <Row className="wrapHomeProduct2">
                <Col xl="12" lg="12" md="12" sm="12">
                  <ReactWOW delay="1s" animation="slideInUp">
                    <h2 className="titleH2 mt-5 animate__animated animate__delay-1s animate__slideInUp">
                      Технічні стеки
                    </h2>
                  </ReactWOW>
                </Col>
              </Row>
              <Row className="wrapRowTechStacksImg">
                <Col xl="12" lg="12" md="12" sm="12">
                  <div id="marquee1" className="marquee">
                    <div id="blockSlider" className="marquee__inner">
                      <Techstacks />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="wrapBlockBGRight">
              <Row className="wrapHomeProduct4">
                <Col xl="12" lg="12" md="12" sm="12">
                  <ReactWOW delay="1s" animation="slideInUp">
                    <h2 className="titleH2 animate__animated animate__delay-1s animate__slideInUp">
                      ШЛЯХ ДО СПІВПРАЦІ
                      <br/>
                      АБО ЧОТИРИ КРОКИ ДО УСПІХУ
                    </h2>
                  </ReactWOW>
                </Col>
              </Row>
              <Row className="mt-5 mb-5">
                <Col xl="12" lg="12" md="12" sm="12">
                  <Container>
                    <CardDeck>
                      <Col xl="3" lg="3" md="6" sm="12" className="colWrapCardNumber">
                        <Card className="wrapCardNumber">
                          <ReactWOW delay="1s" animation="fadeInLeft">
                            <Card.Img
                                src={imgCardOne}
                                className="imgCardNumber animate__animated animate__delay-1s animate__fadeInLeft"
                                alt=" "
                            />
                          </ReactWOW>
                          <ReactWOW delay="1s" animation="fadeInUp">
                            <Card.Body className="wrapBodyCardNumber howItWorks1bg animate__animated animate__delay-1s animate__fadeInUp">
                              <Card.Title className="cardTitle">
                                1. Ініціалізація
                              </Card.Title>
                              <Card.Text className="cardText">
                                Процес розпочинається з ретельного аналізу вашої бізнес-ідеї. Наш бізнес-аналітик визначить ваші вимоги та розробить детальний план розробки. Після цього ми переходимо до фази розробки.
                              </Card.Text>
                            </Card.Body>
                          </ReactWOW>
                        </Card>
                      </Col>
                      <Col xl="3" lg="3" md="6" sm="12" className="colWrapCardNumber">
                        <Card className="wrapCardNumber">
                          <ReactWOW delay="1s" animation="fadeInLeft">
                            <Card.Img
                                src={imgCardTwo}
                                className="imgCardNumber animate__animated animate__delay-1s animate__fadeInLeft"
                                alt=" "
                            />
                          </ReactWOW>
                          <ReactWOW delay="1s" animation="fadeInUp">
                            <Card.Body className="wrapBodyCardNumber howItWorks2bg animate__animated animate__delay-1s animate__fadeInUp">
                              <Card.Title className="cardTitle">
                                2. Планування
                              </Card.Title>
                              <Card.Text className="cardText">
                                На цьому етапі ми збираємо команду, яка має досвід у відповідних для вашого проекту стеках технологій. Ми встановлюємо етапи та контрольні точки проекту, визначаємо потенційні ризики та розраховуємо необхідний розподіл ресурсів.
                              </Card.Text>
                            </Card.Body>
                          </ReactWOW>
                        </Card>
                      </Col>
                      <Col xl="3" lg="3" md="6" sm="12" className="colWrapCardNumber">
                        <Card className="wrapCardNumber">
                          <ReactWOW delay="1s" animation="fadeInLeft">
                            <Card.Img
                                src={imgCardThree}
                                className="imgCardNumber animate__animated animate__delay-1s animate__fadeInLeft"
                                alt=" "
                            />
                          </ReactWOW>
                          <ReactWOW delay="1s" animation="fadeInUp">
                            <Card.Body className="wrapBodyCardNumber howItWorks3bg animate__animated animate__delay-1s animate__fadeInUp">
                              <Card.Title className="cardTitle">
                                3. Розробка
                              </Card.Title>
                              <Card.Text className="cardText">
                                Ми пропонуємо гнучкі підходи до розробки, включаючи Agile (Scrum, Kanban) та Waterfall, призначені для вашого проекту.
                                Протягом процесу розробки ви можете контролювати прогрес та вносити зміни до плану за необхідності.
                              </Card.Text>
                            </Card.Body>
                          </ReactWOW>
                        </Card>
                      </Col>
                      <Col xl="3" lg="3" md="6" sm="12" className="colWrapCardNumber">
                        <Card className="wrapCardNumber">
                          <ReactWOW delay="1s" animation="fadeInLeft">
                            <Card.Img
                                src={imgCardFour}
                                className="imgCardNumber animate__animated animate__delay-1s animate__fadeInLeft"
                                alt=" "
                            />
                          </ReactWOW>
                          <ReactWOW delay="1s" animation="fadeInUp">
                            <Card.Body className="wrapBodyCardNumber howItWorks4bg animate__animated animate__delay-1s animate__fadeInUp">
                              <Card.Title className="cardTitle">
                                4. Завершення
                              </Card.Title>
                              <Card.Text className="cardText">
                                Після ретельного тестування ми запускаємо кінцевий продукт. Ви отримаєте детальний звіт про виконану роботу.
                                Ми продовжуємо комунікацію, оскільки надаємо постійну технічну підтримку, щоб забезпечити довговічність і успіх вашого продукту.
                              </Card.Text>
                            </Card.Body>
                          </ReactWOW>
                        </Card>
                      </Col>
                    </CardDeck>
                  </Container>
                </Col>
              </Row>
              <Row className="wrapHomeProduct5">
                <Col>
                  <h2 className="titleH2">
                    Тематичні дослідження
                  </h2>
                </Col>
              </Row>
              <Row className="align-items-center wrapRowCaruselItemCS">
                <Container>
                  <Carousel className="wrapCarouselCaseStudies">
                    <Carousel.Item>
                      <div className="wrapCaruselItemCS">
                        <img
                            className="caruselHomeCaseStudySlide"
                            src={casestudies1WD}
                            alt="carusel 1"
                        />
                        <Carousel.Caption className="wrapTextBlockCS">
                          <h3 className="h3Carusel">ЧАТ-РОБОТИ</h3>
                          <p className="pCarusel">
                            Наша команда розробила та інтегрувала чат-рішення та чат-боти для оптимізації процесу підтримки клієнтів в контакт-центр страхової компанії.
                          </p>
                          <a href="/ua/case-studies/chat-bots" className="btn buttonOne buttonOneCarusel">
                            Дивитись більше
                          </a>
                        </Carousel.Caption>
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="wrapCaruselItemCS">
                        <img
                            className="caruselHomeCaseStudySlide"
                            src={casestudies2WD}
                            alt="carusel 1"
                        />
                        <Carousel.Caption className="wrapTextBlockCS">
                          <h3 className="h3Carusel">ІНТЕРНЕТ-МАГАЗИН</h3>
                          <p className="pCarusel">
                            Ми розробили та впровадили онлайн-рішення для продажу договорів страхування безпосередньо через веб-сайт компанії, підвищивши доступність та зручність процесу придбання страхових продуктів.
                          </p>
                          <a href="/ua/case-studies/online-store" className="btn buttonOne buttonOneCarusel">
                            Дивитись більше
                          </a>
                        </Carousel.Caption>
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="wrapCaruselItemCS">
                        <img
                            className="caruselHomeCaseStudySlide"
                            src={casestudies3WD}
                            alt="carusel 1"
                        />
                        <Carousel.Caption className="wrapTextBlockCS">
                          <h3 className="h3Carusel">API - ІНСТРУМЕНТ ПРОДАЖУ</h3>
                          <p className="pCarusel">
                            Ми створили індивідуальне рішення, яке використовує API для покращення та оптимізації процесу продажу страхових продуктів, забезпечуючи безперешкодний досвід як для клієнтів, так і для агентів.
                          </p>
                          <a href="/ua/case-studies/api-sales-tool" className="btn buttonOne buttonOneCarusel">
                            Дивитись більше
                          </a>
                        </Carousel.Caption>
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="wrapCaruselItemCS">
                        <img
                            className="caruselHomeCaseStudySlide"
                            src={casestudies4WD}
                            alt="carusel 2"
                        />
                        <Carousel.Caption className="wrapTextBlockCS">
                          <h3 className="h3Carusel">ОНЛАЙН АГЕНТ</h3>
                          <p className="pCarusel">
                            Наша команда відіграла ключову роль у впровадженні інноваційного ІТ-рішення та програми рекомендацій для залучення нових клієнтів для страхової компанії. Цей унікальний підхід сприяв залученню клієнтів та зростанню бізнесу.
                          </p>
                          <a href="/ua/product/online-insurance-products" className="btn buttonOne buttonOneCarusel">
                            Дивитись більше
                          </a>
                        </Carousel.Caption>
                      </div>
                    </Carousel.Item>
                  </Carousel>
                </Container>
              </Row>
              <Row className="mt-5 mb-5">
                <Col xl="12" lg="12" md="12" sm="12">
                  <ReactWOW delay="1s" animation="slideInUp">
                    <h2 className="titleH2 mt-5 animate__animated animate__delay-1s animate__slideInUp">
                      НАША КОМАНДА
                    </h2>
                  </ReactWOW>
                  <ReactWOW delay="1s" animation="fadeInUp">
                    <p className="titleP animate__animated animate__delay-1s animate__fadeInUp">
                      Тільки виняткова команда може створити видатні програмні рішення
                    </p>
                  </ReactWOW>
                </Col>
              </Row>
              <div className="wrapBlockBGForm">
                <Row>
                  <Col xl="6" lg="6" md="6" sm="12">
                    {/* 1 */}
                    <Container>
                      <div className="wrap-conteiner-img">
                        <img
                            src={ourteam1WD}
                            alt=" "
                            className="cardImgItems"
                        />
                      </div>
                      <div className="wrap-conteiner-img">
                        <img
                            src={ourteam2WD}
                            alt=" "
                            className="cardImgItems"
                        />
                      </div>
                      <div className="wrap-conteiner-img">
                        <Card.Img
                            src={ourteam3WD}
                            alt=" "
                            className="cardImgItems"
                        />
                      </div>
                    </Container>
                    {/* 2 */}
                    <Container>
                      <div className="wrap-conteiner-img">
                        <img
                            src={ourteam4WD}
                            alt=" "
                            className="cardImgItems"
                        />
                      </div>
                      <div className="wrap-conteiner-img">
                        <img
                            src={ourteam5WD}
                            alt=" "
                            className="cardImgItems"
                        />
                      </div>
                      <div className="wrap-conteiner-img">
                        <img
                            src={ourteam6WD}
                            alt=" "
                            className="cardImgItems"
                        />
                      </div>
                    </Container>
                    {/* 3 */}
                    <Container>
                      <div className="wrap-conteiner-img">
                        <img
                            src={ourteam7WD}
                            alt=" "
                            className="cardImgItems"
                        />
                      </div>
                      <div className="wrap-conteiner-img">
                        <img
                            src={ourteam8WD}
                            alt=" "
                            className="cardImgItems"
                        />
                      </div>
                      <div className="wrap-conteiner-img">
                        <a href="/ua/careers" className="imgOurTeam9">
                          <img
                              src={ourteam9WD}
                              alt=" "
                              className="cardImgItems"
                          />
                        </a>
                      </div>
                    </Container>
                  </Col>
                  <Col xl="6" lg="6" md="6" sm="12" className="wrapHomeProduct6">
                    <ReactWOW delay="1s" animation="fadeInUpBig">
                      <div className="animate__animated animate__delay-1s animate__fadeInUpBig">
                        <h3 className="h3OurTeam">ХТО МИ</h3>
                        <p className="pOurTeam">
                          Ми є компанією з розробки програмного забезпечення з центральним офісом у Києві, Україна.
                        </p>
                        <p className="pOurTeam">
                          Наша команда налічує понад 100 професіоналів , які створюють та вдосконалюють інноваційні рішення, побудовані на технологіях, креативності та пристрастю до інновацій.
                        </p>
                        <p className="pOurTeam">
                          Наша глибока експертиза в передових технологіях та тонкощах страхової галузі дає нам можливість скеровувати клієнтів на шляху цифровізації.
                        </p>
                        <a href="/ua/careers" className="btn buttonOne">
                          Дивитись більше
                        </a>
                      </div>
                    </ReactWOW>
                  </Col>
                </Row>


                <Row className="mt-5 mb-5">
                  <Col xl={{ span: 8, offset: 2 }} lg={{ span: 10, offset: 1 }} md="12" sm="12">
                    <ReactWOW delay="1s" animation="slideInUp">
                      <h2 className="titleH2 mt-5 animate__animated animate__delay-1s animate__slideInUp">
                        Наші клієнти
                      </h2>
                    </ReactWOW>
                    <ReactWOW delay="1s" animation="fadeInUp">
                      <p className="titleP animate__animated animate__delay-1s animate__fadeInUp">
                        Партнерство з найкращими
                      </p>
                    </ReactWOW>
                    <Row className="mt-5 mb-5 wrap-our-customers-card">
                      <Col xl="6" lg="6" md="12" sm="12">
                        <div className="wrap-our-customers-card-item">
                          <img
                              src={ourcustomers3WD}
                              className="our-customers-card-img our-customers-card-img3"
                              title=""
                              alt=" "
                          />
                        </div>
                      </Col>
                      <Col xl="6" lg="6" md="12" sm="12">
                        <div className="wrap-our-customers-card-item">
                          <img
                              src={ourcustomers2WD}
                              className="our-customers-card-img our-customers-card-img2"
                              title=""
                              alt=" "
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>


                <Row className="wrapForm" id="idWrapForm">
                  <Col
                      // xl={{ span: 8, offset: 2 }}
                      // lg={{ span: 10, offset: 1 }}
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                  >
                    <div className="wrapFormCard">
                      <ReactWOW delay="1s" animation="slideInUp">
                        <h2 className="titleH2 mt-5 animate__animated animate__delay-1s animate__slideInUp">
                          Давайте обговоримо ваші ідеї
                        </h2>
                      </ReactWOW>
                      <ReactWOW delay="1s" animation="flipInX">
                        <p className="titleP animate__animated animate__delay-1s animate__flipInX">
                          Просто заповніть форму або напишіть нам на адресу info@sagax.software
                        </p>
                      </ReactWOW>
                      <ReactWOW delay="1s" animation="fadeInUpBig">
                        <img
                            className="formFigura1 animate__animated animate__delay-1s animate__fadeInUpBig"
                            src={formFigura1}
                            alt=" "
                        />
                      </ReactWOW>
                      <ReactWOW delay="1s" animation="fadeInTopLeft">
                        <img
                            className="formFigura3 animate__animated animate__delay-1s animate__fadeInTopLeft"
                            src={formFigura3}
                            alt=" "
                        />
                      </ReactWOW>
                      <FormFormik/>
                      <ReactWOW delay="1s" animation="fadeInTopRight">
                        <img
                            className="formFigura2 animate__animated animate__delay-1s animate__fadeInTopRight"
                            src={formFigura2}
                            alt=" "
                        />
                      </ReactWOW>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Container>
      </div>
  );
}

export default HomePage;
